import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import * as UserActions from '../../actions/UserActions'
import * as Helper from '../../utils/Helper'
import Header from './parts/Header'
import Footer from '../after_login/parts/Footer'
import { Helmet } from "react-helmet";
// import Lottie from 'react-lottie';
// import * as rocket from '../lottie/36418-cecil-portfolio-background.json'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
// import { Link } from 'react-scroll'
// import eval_sample4 from '../../images/eval_sample4.jpg'
import shabelabo_web_top from '../../images/shabelabo_web_top.png'
import point_whiteback from '../../images/point_whiteback.png'
import ContactFormPart from './parts/ContactFormPart'

// // lottie
// let lottieOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: rocket.default,
//   rendererSettings: {
//     preserveAspectRatio: 'xMidYMid slice'
//   }
// };

// example of specifying audio url
let code1 = [
  "import axios from 'axios'",
  "",
  "let results_1 = await axios.post(<APIのエンドポイント>, {",
  " audio_url: <音声ファイルのURL>,",
  " response_type: 'v2',",
  "}, {",
  " headers: {",
  "  'Accept': 'application/json',",
  "  'Authorization': <APIのキー>,",
  " },",
  "})",
]
let code_str1 = code1.join("\n")

// example of sending audio
let code2 = [
  "import axios from 'axios'",
  "",
  "let audio_data = fs.readFileSync(<音声ファイルのパス>)",
  "let audio_base64 = audio_data.toString('base64')",
  "",
  "let results_1 = await axios.post(<APIのエンドポイント>, {",
  "  audio: audio_base64,",
  "  response_type: 'v2',",
  "}, {",
  "  headers: {",
  "    'Accept': 'application/json',",
  "    'Authorization': <APIのキー>,",
  "  },",
  "})"
]
let code_str2 = code2.join("\n")


// AppStart
const AppStart = (props) => {

  let navigate = useNavigate();
  let dispatch = useDispatch();

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    let _rtnObj = await Helper.loginWithToken()
    if (_rtnObj.status === true) {

      // update props
      dispatch(UserActions.loginWithEmail(_rtnObj.token_params))

      // redirect
      navigate("/dashboard")

    }
  }


  // if domain is alphatest.shabelab.com
  // then show nothing...
  if (window.location.hostname === "alphatest.shabelab.com") {

    return (
      <div>

        <Helmet>
          <meta charSet="utf-8" />
          <title>喋ラボCLOUD | トップ</title>
          <meta name="description" content="喋ラボCLOUDは喋ラボの音声認識AIのクラウドサービスです。" />
        </Helmet>

        <div style={{
          backgroundColor: '#008CC8',
        }}>

          {/* header */}
          <Header />

        </div>


        {/* footer */}
        <Footer />

      </div>
    )


  }


  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>トップ</title>
        <meta name="description" content="" />
      </Helmet>

      <div style={{
        backgroundColor: '#008CC8',
      }}>

        {/* header */}
        <Header />

      </div>

      {/* body */}
      <div id="main_contents1" style={{
        backgroundColor: '#ffffff',
      }}>

        <Container>


  

     

        </Container>
      </div>



      {/* footer */}
      <Footer />

    </div>
  )
}

export default AppStart
